/**
 * Disponibilidad del producto en la ficha (CAT-02).
 *
 * El numero que se muestra es el que informo Random en su ultima
 * sincronizacion, y se dice cuando fue: el sitio nunca inventa un stock, y el
 * comprador merece saber que tan fresco es el dato. La verificacion firme
 * ocurre al pagar, no aca (CHK-05).
 */
import type { UnidadMedida } from '@elcarpintero/compartido';

import { fechaHora } from '../../utilidades/formato';
import { textoDisponibles } from '../../utilidades/paquete';

/** Bajo esta cantidad se muestra urgencia en vez del numero a secas. */
const STOCK_CRITICO = 4;

export interface CajaStockProps {
  /** El stock viene en paquetes cuando se vende de a paquete (VTA-01). */
  producto: {
    stock: number;
    sincronizadoEn: string | null;
    unidadesPorPaquete: number;
    unidadMedida: UnidadMedida;
  };
}

export function CajaStock({ producto }: CajaStockProps) {
  const { stock, sincronizadoEn } = producto;
  const agotado = stock <= 0;
  const critico = !agotado && stock <= STOCK_CRITICO;
  const clase = agotado ? 'critico' : critico ? 'alerta' : 'ok';

  return (
    <p className={`ficha-stock-caja ficha-stock-caja--${clase}`}>
      <span className="punto punto-vivo" />
      <span>
        <strong>
          {agotado
            ? 'Sin stock en este momento'
            : `${textoDisponibles(producto, stock)} ${stock === 1 ? 'disponible' : 'disponibles'}`}
        </strong>
        <span className="d">
          {agotado
            ? 'Consulta por WhatsApp: solemos reponer en 5 a 10 días.'
            : sincronizadoEn !== null
              ? // Sin punto final: el formato de hora en es-CL ya termina en uno ("a. m.").
                `Stock informado por bodega el ${fechaHora(sincronizadoEn)}`
              : 'Confirmamos el stock al momento de pagar.'}
        </span>
      </span>
    </p>
  );
}
